import { render, staticRenderFns } from "./invadobays.vue?vue&type=template&id=29a8d248&scoped=true&"
import script from "./invadobays.vue?vue&type=script&lang=js&"
export * from "./invadobays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a8d248",
  null
  
)

export default component.exports